import React, { useState, useEffect } from 'react';
// import axios from 'axios'; // <-- Removed this import
import api from '../utils/api'; // <-- Added this import
import { Container, Card, Form, Button, Row, Col, ListGroup, Alert, Spinner } from 'react-bootstrap';

const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const AdminHoursManager = () => {
    const [shopHours, setShopHours] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [newHoliday, setNewHoliday] = useState({ date: '', description: '' });

    useEffect(() => {
        fetchShopHours();
    }, []);

    const fetchShopHours = async () => {
        try {
            setLoading(true);
            const response = await api.get('/opening-hours'); // <-- Changed to api.get
            setShopHours(response.data);
            setError(null);
        } catch (err) {
            setError('Failed to fetch hours. Please check the backend connection.');
            setShopHours({ openingHours: daysOfWeek.map(day => ({ day, openTime: '09:00', closeTime: '22:00', isClosed: false })), holidays: [] });
        } finally {
            setLoading(false);
        }
    };

    const handleHourChange = (day, field, value) => {
        const updatedHours = shopHours.openingHours.map(item =>
            item.day === day ? { ...item, [field]: value } : item
        );
        setShopHours({ ...shopHours, openingHours: updatedHours });
    };

    const handleUpdateHours = async () => {
        try {
            setLoading(true);
            await api.put('/admin/opening-hours', { openingHours: shopHours.openingHours }); // <-- Changed to api.put
            alert('Opening hours updated successfully!');
            fetchShopHours();
        } catch (err) {
            setError('Failed to update hours. Make sure the backend is running and you are an admin.');
        } finally {
            setLoading(false);
        }
    };

    const handleAddHoliday = async () => {
        try {
            setLoading(true);
            await api.post('/admin/holidays', newHoliday); // <-- Changed to api.post
            alert('Holiday added successfully!');
            setNewHoliday({ date: '', description: '' }); // Clear form
            fetchShopHours();
        } catch (err) {
            setError('Failed to add holiday. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Container className="text-center mt-5"><Spinner animation="border" /></Container>;
    }

    return (
        <Container className="my-5">
            <h2 className="text-center mb-4">Admin: Manage Shop Hours</h2>
            {error && <Alert variant="danger">{error}</Alert>}

            <Card className="mb-4 shadow-sm">
                <Card.Header as="h5">Set Daily Hours</Card.Header>
                <Card.Body>
                    <Form>
                        {shopHours.openingHours.map(day => (
                            <Row key={day.day} className="mb-2 align-items-center">
                                <Col md={3}>
                                    <Form.Label className="mb-0">{day.day}:</Form.Label>
                                </Col>
                                <Col md={3}>
                                    <Form.Control
                                        type="time"
                                        value={day.openTime}
                                        onChange={(e) => handleHourChange(day.day, 'openTime', e.target.value)}
                                        disabled={day.isClosed}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Control
                                        type="time"
                                        value={day.closeTime}
                                        onChange={(e) => handleHourChange(day.day, 'closeTime', e.target.value)}
                                        disabled={day.isClosed}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Check
                                        type="checkbox"
                                        label="Closed"
                                        checked={day.isClosed}
                                        onChange={(e) => handleHourChange(day.day, 'isClosed', e.target.checked)}
                                    />
                                </Col>
                            </Row>
                        ))}
                        <Button variant="primary" onClick={handleUpdateHours} className="mt-3">
                            Save Daily Hours
                        </Button>
                    </Form>
                </Card.Body>
            </Card>

            <Card className="shadow-sm">
                <Card.Header as="h5">Add Holidays</Card.Header>
                <Card.Body>
                    <Form>
                        <Row>
                            <Col md={5}>
                                <Form.Control type="date" value={newHoliday.date} onChange={(e) => setNewHoliday({...newHoliday, date: e.target.value})} />
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" placeholder="Description" value={newHoliday.description} onChange={(e) => setNewHoliday({...newHoliday, description: e.target.value})} />
                            </Col>
                            <Col md={2}>
                                <Button onClick={handleAddHoliday} disabled={!newHoliday.date || !newHoliday.description}>Add</Button>
                            </Col>
                        </Row>
                    </Form>
                    <h6 className="mt-4">Upcoming Holidays:</h6>
                    <ListGroup>
                        {shopHours.holidays.map(holiday => (
                            <ListGroup.Item key={holiday._id}>
                                {new Date(holiday.date).toLocaleDateString()} - {holiday.description}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default AdminHoursManager;